// @ts-check
/* eslint-disable sort-imports */
import {digg} from "diggerize"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import memo from "set-state-compare/build/memo.js"
import ModelClassTable from "./model-class-table"
import React from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import ShowNav from "./show-nav"
import useModel from "../use-model.js"
import useQueryParams from "on-location-changed/build/use-query-params.js"
import {View} from "react-native"

/**
 * @typedef {object} Props
 * @property {Function} modelClass
 * @property {string} modelId
 */
/** @typedef {Record<string, never>} State */
export default memo(shapeComponent(/** @augments {ShapeComponent<Props, State>} */ class ApiMakerSuperAdminShowReflectionPage extends ShapeComponent {
  static propTypes = propTypesExact({
    modelClass: PropTypes.func.isRequired,
    modelId: PropTypes.string.isRequired
  })

  render() {
    const {modelClass} = this.p
    const queryParams = useQueryParams()
    const camelizedLower = digg(modelClass.modelClassData(), "camelizedLower")
    const useModelResult = useModel(modelClass, {loadByQueryParam: ({queryParams}) => digg(queryParams, "model_id")})
    const model = digg(useModelResult, camelizedLower)
    const reflections = modelClass.reflections()
    const reflection = reflections.find((reflectionI) => reflectionI.name() == queryParams.model_reflection)
    const reflectionModelClass = reflection.modelClass()
    let collection

    if (model) collection = model[reflection.name()]()

    return (
      <View testID="super-admin/show-reflection-page">
        {model &&
          <ShowNav model={model} modelClass={modelClass} />
        }
        {collection &&
          <ModelClassTable
            collection={collection}
            key={reflectionModelClass.modelName().human()}
            modelClass={reflectionModelClass}
          />
        }
      </View>
    )
  }
}))
